<script>
    import Chart from 'chart.js';
    import {generateChart} from 'vue-chartjs';

    import { mapGetters } from 'vuex';

    Chart.defaults.lineWithShadow = Chart.defaults.line
    Chart.controllers.lineWithShadow = Chart.controllers.line.extend({
        draw: function (ease) {
            var ctx = this.chart.ctx
            ctx.save()
            ctx.shadowColor = 'rgba(0,0,0,0.15)'
            ctx.shadowBlur = 10
            ctx.shadowOffsetX = 0
            ctx.shadowOffsetY = 0
            ctx.responsive = true
            Chart.controllers.line.prototype.draw.call(this, ease)
            ctx.restore()
        }
    })

    const AreaShadow = generateChart('area-with-shadow', 'lineWithShadow')

    export default {
        extends: AreaShadow,

        props: ['data', 'prefix'],

        data() {
            return {

            }
        },

        computed: {
            ...mapGetters({
                colors: 'getThemeColors',
            }),

            options() {
                let prefix = this.prefix;

                return {
                    legend: {
                        display: false
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        yAxes: [
                            {
                                gridLines: {
                                    display: true,
                                    lineWidth: 1,
                                    color: 'rgba(0,0,0,0.1)',
                                    drawBorder: false
                                },
                                ticks: {
                                    beginAtZero: true,
                                    padding: 20,
                                    userCallback: function(value, index, values) {
                                        // Convert the number to a string and splite the string every 3 charaters from the end
                                        value = value.toString();
                                        value = value.split(/(?=(?:...)*$)/);

                                        // Convert the array to a string and format the output
                                        value = value.join(',');
                                        if (prefix) {
                                            return prefix + value;
                                        }
                                        return value;
                                    }
                                }
                            }
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    display: false
                                }
                            }
                        ]
                    },
                    tooltips: {
                        backgroundColor: this.colors.foregroundColor,
                        titleFontColor: this.colors.primaryColor,
                        borderColor: this.colors.separatorColor,
                        borderWidth: 0.5,
                        bodyFontColor: this.colors.primaryColor,
                        bodySpacing: 10,
                        xPadding: 15,
                        yPadding: 15,
                        cornerRadius: 0.15,
                        callbacks: {
                            label: function(tooltipItem, data) {
                                data = data['datasets'][0]['data'][tooltipItem['index']].toString();
                                let leftData = data.split('.')[0].split(/(?=(?:...)*$)/);
                                let rightData = "." + data.split('.')[1];

                                // Convert the array to a string and format the output
                                data = leftData.join(',') + rightData;
                                // return prefix + value;

                                if (prefix) {
                                    return prefix + data;
                                }
                                return data;
                            }
                        }
                    },
                };
            }
        },

        mounted() {
            this.renderChart(this.data, this.options)
        }
    }
</script>
